import { useQuery } from "@tanstack/react-query";
import type {
  Resources,
  resourceAutoLogFetchInterface
} from "@dealer-center/ddc-pages-resource-auto-log-interface";
const queryKeyBase = "ddc-pages-resource-auto-log";

export function useResourceAutoLogAPIInterface({
  dealerId
}: resourceAutoLogFetchInterface) {
  return useQuery({
    queryKey: [queryKeyBase, { dealerId }],
    queryFn: () => getFunction(dealerId?.trim() || ""),
    enabled: !!dealerId && dealerId.trim().length > 0,
    retry: 1,
    staleTime: 1000 * 60 * 5 // 5 minutes
  });
}

const getFunction = async (name: string): Promise<Resources[]> => {
  const res = await fetch("/landing/nxlambda/resourceAutoLog/" + name);
  if (res.ok) {
    return res.json() as Promise<Resources[]>;
  } else {
    throw new Error(res.statusText);
  }
};
